import React from 'react';
import PropTypes from 'prop-types';
import Banner from './Banner';

export const VOTING_HEADER =
    'It’s National Voter Registration Day! Are you registered?';

const VotingBanner = (props) => {
    const trackingData = {
        type: 'TRACK_VOTING_BANNER_CLICK',
        meta: {
            analytics: {
                action: 'VotingBannerClick',
                category: props.category,
            },
        },
    };

    const destinationURL = 'https://headcount.turbovote.org/?r=eventbrite';

    return (
        <Banner leftAccentColor="#F05537" style="" header={VOTING_HEADER}>
            <span>
                We partnered with HeadCount to help you get registered to vote
                (or check your status)!{' '}
                <a
                    onClick={() => {
                        props.handleTracking(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL}
                >
                    Register to vote
                </a>
                .
            </span>
        </Banner>
    );
};

VotingBanner.propTypes = {
    handleTracking: PropTypes.func,
    trackingParams: PropTypes.string,
    category: PropTypes.string,
};

export default VotingBanner;
